import Swal from 'sweetalert2';

export default function useImageValidation() {
  const isImageFile = (file: File): boolean => {
    return (
      file.type === 'image/png' ||
      file.type === 'image/svg+xml' ||
      file.name.toLowerCase().endsWith('.png') ||
      file.name.toLowerCase().endsWith('.svg')
    );
  };

  const filterImageFiles = (files: FileList | null): File[] => {
    if (!files || files.length === 0) return [];

    return Array.from(files).filter(isImageFile);
  };

  const showError = (message: string) => {
    Swal.fire({
      title: 'Erro',
      text: message,
      icon: 'error',
      confirmButtonColor: 'var(--theme-secondary)',
    });
  };

  return {
    isImageFile,
    filterImageFiles,
    showError,
  };
}
